/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdownProspect200,
  GetApiV1TagDropdownProspect401,
  GetApiV1TagDropdownProspect500,
  GetApiV1TagDropdownProspectQueryParams,
  GetApiV1TagDropdownProspectQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdownProspect.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1TagDropdownProspectQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    ids: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1TagDropdownProspectQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdownProspect200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdownProspect200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdownProspect401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownProspect401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdownProspect500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownProspect500>;

export const getApiV1TagDropdownProspectQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdownProspect200Schema,
) as unknown as ToZod<GetApiV1TagDropdownProspectQueryResponse>;
